import {  getFirestore, doc, deleteDoc } from "firebase/firestore";
import firebase_app from "../config";

export default async function deleteData(collection,id,cb) {
    const db = getFirestore(firebase_app)
    try {
        await deleteDoc(doc(db,collection,id));
        cb && cb({status:true})
    } catch(err){
        cb && cb({status:false,err})
    }
}